import { OrganizationState } from 'common/features/store/duck/organization/duck';
import { PaymentType } from 'common/api/e-comm/payment-types';

export const orgSupportsShipToHome = (org: OrganizationState): null | boolean => {
    if (!org.paymentTypes) {
        return null;
    }
    return org.paymentTypes.some((allowedType) => {
        return allowedType === PaymentType.BankAccount || allowedType === PaymentType.CreditCard;
    });
};

export const getDaysInMonth = (month: number, year: number) => {
    return new Date(year, month, 0).getDate();
};

export const scrollToElement = (el: Element) => {
    const { top } = el.getBoundingClientRect();
    window.scrollBy({
        left: 0,
        top,
        behavior: 'smooth',
    });
};

export const formatSize = (bytes: number): string => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    if (bytes == 0) {
        return '0 Byte';
    }
    const i = Math.trunc(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
};

interface Rect {
    left: number;
    top: number;
    right: number;
    bottom: number;
}

export const intersects = (rectA: Rect, rectB: Rect) => {
    return (
        rectA.left < rectB.right &&
        rectA.right > rectB.left &&
        rectA.top < rectB.bottom &&
        rectA.bottom > rectB.top
    );
};

export const round = (number: number, precision: number) => {
    precision =
        precision == null
            ? 0
            : precision >= 0
            ? Math.min(precision, 292)
            : Math.max(precision, -292);
    if (precision) {
        // Shift with exponential notation to avoid floating-point issues.
        // See [MDN](https://mdn.io/round#Examples) for more details.
        let pair = `${number}e`.split('e');
        const value = Math.round(+`${pair[0]}e${+pair[1] + precision}`);

        pair = `${value}e`.split('e');
        return +`${pair[0]}e${+pair[1] - precision}`;
    }
    return Math.round(number);
};
